export const getAnalysis = async () => {
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${process.env.REACT_APP_AWS_USER_TOKEN}`,
    },
  };

  let response = {};

  const processExe = () => {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.REACT_APP_AWS_USER_ENDPOINT}/get-analysis`, options)
        .then((resp) => resp.json())
        .then((data) => {
          response = {
            ...data,
          };
          resolve(data);
        })
        .catch((error) => {
          console.log(
            `[Helpers -> Get Analysis]: Error in getting analysis -> ${error}`
          );
          response = {
            status: 500,
            message: `Error in getting analysis: [${error.message}]`,
          };
          reject(response);
        });
    });
  };

  await processExe();
  return response;
};
